var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import React, { useState } from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import TocStockHeader from "../../../CommonTocComponent/TocHeader/TocStockHeader";
import SingleHeadingText from "../../../CommonTocComponent/TocHeader/SingleHeadingText";
import { Col, Row } from "react-bootstrap";
import DiffrentBankAccountData from "./DiffrentBankAccountData";
var DiffrentBankAccount = function (props) {
    var _a;
    var device = DeviceContext();
    var _b = __read(useState((_a = props.selectedBank) === null || _a === void 0 ? void 0 : _a.bnkAcNo), 2), selectedAccount = _b[0], setSelectedAccount = _b[1];
    var apply = function () {
        props.setSelectedBank(props.bankList.find(function (x) { return x.bnkAcNo === selectedAccount; }));
        props.next();
    };
    return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
        React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Choose different bank account", closeFunction: function () {
                    props.back();
                } }) }),
        React.createElement("div", { className: "outer-body-section" },
            React.createElement(DiffrentBankAccountData, { bankList: props.bankList, selectedAccount: selectedAccount, setSelectedAccount: setSelectedAccount })),
        React.createElement("div", { className: "bottom-contents" },
            React.createElement(Row, { className: "bottombtnsection mb-2" },
                React.createElement(Col, { lg: 6, xs: 6 },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "w-100", onClick: function () { return props.back(); } })),
                React.createElement(Col, { lg: 6, xs: 6 },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100", onClick: function () { return apply(); } })))))) : (React.createElement(GenericDrawer, { show: true, setShow: props.setShow, headerComp: React.createElement(React.Fragment, null,
            React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Choose different bank account")), bodyComp: React.createElement(React.Fragment, null,
            React.createElement("div", { className: "outer-body-section overflow-scroll-300 " },
                React.createElement(DiffrentBankAccountData, { bankList: props.bankList, selectedAccount: selectedAccount, setSelectedAccount: setSelectedAccount })),
            React.createElement("div", { className: "bottom-contents" },
                React.createElement(Row, { className: "bottombtnsection mb-2 pb-2 pt-3 bg-white" },
                    React.createElement(Col, { lg: 6, xs: 6 },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "w-100", onClick: function () { return props.back(); } })),
                    React.createElement(Col, { lg: 6, xs: 6 },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100", onClick: function () { return apply(); } }))))) }))));
};
export default DiffrentBankAccount;
